import {ImageMeta} from './imageMeta'

/**
 * Class representing a content item
 */
export default class ImageUpdate {
  /**
   * Create an object for image update.
   * @param {AreaOfDamageImage[]} areaOfDamageImages - the array of damaged areas images with details
   * @param {ImageMeta} options.wholeCaseImage
   * @param {ImageMeta} options.badgeImage - badge image
   * @param {ImageMeta} options.baggageTagImage - image of baggage tag
   */
  constructor (options) {
    this.areaOfDamageImages = options.areaOfDamageImages !== undefined ? options.areaOfDamageImages : []
    this.wholeCaseImage = options.wholeCaseImage
    this.badgeImage = options.badgeImage
    this.baggageTagImage = options.baggageTagImage
  }

  get areaOfDamageImages () {
    return this._areaOfDamageImages
  }

  set areaOfDamageImages (value) {
    this._areaOfDamageImages = value
  }

  get wholeCaseImage () {
    return this._wholeCaseImage
  }

  set wholeCaseImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('wholeCaseImage is not an instance of ImageMeta')
    }
    this._wholeCaseImage = value
  }

  get badgeImage () {
    return this._badgeImage
  }

  set badgeImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('badgeImage is not an instance of ImageMeta')
    }
    this._badgeImage = value
  }

  get baggageTagImage () {
    return this._baggageTagImage
  }

  set baggageTagImage (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('baggageTagImage is not an instance of ImageMeta')
    }
    this._baggageTagImage = value
  }

  toJSON () {
    return {
      areaOfDamageImages: this._areaOfDamageImages,
      wholeCaseImage: this._wholeCaseImage,
      badgeImage: this._badgeImage,
      baggageTagImage: this._baggageTagImage
    }
  }
}
